import React from 'react';
import { EffectsVideo as Video } from '@/components/video-effects/EffectsVideo';
import { PreviewIntervalVideo } from '@/components/preview/PreviewIntervalVideo';

export type ClipPlaybackMode = 'html5' | 'media';

/** Shared clip video for Player (HTML5) vs headless render (@remotion/media /
 *  Mediabunny). The canvas decoder ignores CSS object-fit, so fit is a PROP. */
export const ClipPlaybackVideo: React.FC<{
  videoUrl: string;
  trimBefore: number;
  trimAfter: number;
  fps: number;
  volume: number | ((frame: number) => number);
  objectFit?: 'contain' | 'cover' | 'fill';
  isMuted?: boolean;
  playback?: ClipPlaybackMode;
  style?: React.CSSProperties;
  onMediaError?: (error: Error) => void;
}> = ({
  videoUrl,
  trimBefore,
  trimAfter,
  fps,
  volume,
  objectFit = 'contain',
  isMuted = false,
  playback = 'media',
  style,
  onMediaError,
}) => {
  if (playback === 'html5') {
    return (
      <PreviewIntervalVideo
        videoUrl={videoUrl}
        trimBefore={trimBefore}
        trimAfter={trimAfter}
        fps={fps}
        volume={volume}
        objectFit={objectFit}
        isMuted={isMuted}
        style={style}
        onMediaError={onMediaError}
      />
    );
  }

  return (
    <Video
      src={videoUrl}
      trimBefore={trimBefore}
      trimAfter={trimAfter}
      muted={isMuted || volume === 0}
      volume={volume}
      objectFit={objectFit}
      style={{ width: '100%', height: '100%', ...style }}
      onError={onMediaError
        ? (error) => {
            onMediaError(error);
            return 'fallback';
          }
        : undefined}
    />
  );
};
